import { ScaleLinear } from 'd3-scale';
import { deriveYAxisLabelProps } from '../axisLabel/deriveLabelProps';
import { YAxisLabelProps } from '../axisLabel/YAxisLabel';
import { NumberFormat, postfixNumber } from '@instinet-analytics/core-lib';
import {
    lastBinActualTooltip,
    lastBinExpectedTooltip,
} from 'widgets/fillsGraph/expectedVsActual/help/expectedVsActualLegendTooltips';

export function deriveLastBinYAxisLabelProps(
    chartMax: number,
    lastBucketExpectedVolume: number | undefined,
    lastBucketActualVolume: number | undefined,
    numberFormat: NumberFormat,
    yScale: ScaleLinear<number, number>,
    height: number,
    width: number,
    volumesArePercentages?: boolean
): Record<'actual' | 'expected', YAxisLabelProps> {
    const valueSuffix = volumesArePercentages ? '%' : '';

    return deriveYAxisLabelProps(
        [
            {
                key: 'expected',
                type: 'Last Bin Expected Volume',
                tooltip: lastBinExpectedTooltip,
                value: chartMax,
                displayValue: Math.round(lastBucketExpectedVolume ?? 0),
            },
            {
                key: 'actual',
                type: 'Last Bin Actual Volume',
                tooltip: lastBinActualTooltip,
                value: chartMax,
                displayValue: Math.round(lastBucketActualVolume ?? 0),
            },
        ],
        postfixNumber,
        yScale,
        height,
        width,
        valueSuffix
    );
}
